import { css } from 'styled-components';
import { CFTokens } from '../../../tokens';
import { CFBaseStatusBadgeHelpers } from './styles';
export const CFBaseStatusBadgeStyles = {
    Label: css `
    color: ${CFBaseStatusBadgeHelpers.textColor};
    ${CFBaseStatusBadgeHelpers.typeSpec};
  `,
    Root: css `
    padding: 0 ${CFTokens.SPACER.C}px;
    height: ${CFBaseStatusBadgeHelpers.rootSize}px;
    display: flex;
    flex-direction: row;
    gap: ${CFTokens.SPACER.A}px;
    align-items: center;
    justify-content: center;
    border: 1px solid ${CFBaseStatusBadgeHelpers.rootBorderColor};
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    background-color: ${CFBaseStatusBadgeHelpers.rootColor};
  `,
};
